import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';

import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

const env = process.env.NODE_ENV;

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, thunk];

export function configureStore(initialState) {
    const store = createStore(
        reducers,
        initialState,
        env === 'development' ?
        composeWithDevTools(applyMiddleware(...middlewares)) :
        applyMiddleware(...middlewares)
    );

    sagaMiddleware.run(sagas);

    if (module.hot) {
        module.hot.accept('./reducers', () => {
            const nextRootReducer = require('./reducers');
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}